import React, { useEffect } from 'react';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import Card from '../../../../muiComponents/Card';
import {
    useProperty,
    usePropertyFetching,
    usePropertyValidation,
} from '../../../contextsProperty/ContextProperties';
import { PROGRESS_MAIN_INFORMATION_TAB } from '../../../../types/properties/propertyTypes';
import LoadingTab from '../LoadingTab';
import Title from '../Title';

export default function Commercial() {
    const { name, primary, handleInputChange } = useProperty();
    const { handleIsValidated, errors, isValidated, handleValidate } =
        usePropertyValidation();
    const { isFetching } = usePropertyFetching();

    useEffect(() => {
        return () => handleIsValidated(false);
    }, []);

    const handleBlur = () => {
        if (isValidated) {
            handleValidate(PROGRESS_MAIN_INFORMATION_TAB.COMMERCIAL);
        }
    };

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'what_is_your_property_name?'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <TextInput
                    labelText='hotel_name'
                    handleChange={e =>
                        handleInputChange('name', e.target.value)
                    }
                    value={name}
                    errorMessage={errors.name}
                    onBlur={handleBlur}
                    name='name'
                    type='text'
                    required
                    disabled={!primary}
                    variant={!primary ? 'filled' : 'outlined'}
                    error={!!errors.name}
                />
            </Card>
        </div>
    );
}
